/* Pop-up de newsletter (sections/gs-popup-news.liquid), Ganga Shop V2.
   Sale a los X s (20) o al pasar la mitad de la página, lo primero; la mitad cuenta recién desde el mínimo (8 s).
   La mitad se mide UNA vez tras el primer scroll y se vigila con IntersectionObserver: ningún handler de scroll mide.
   Nunca con carrito, menú, buscador, vista rápida, otro diálogo o un campo con foco abiertos: reintenta cada 3 s.
   localStorage «gs-news» (try/catch; si no se puede guardar, no sale): «suscripto» = no sale más;
   «cerrado:<fecha>» (al mostrarse y al cerrarse) = vuelve a los X días (7).
   El formulario nativo de Shopify se envía normal (pasa por su hCaptcha) y al volver con #GsNews-... el pop-up se
   abre solo: customer_posted=true = éxito; form_type=customer sin error = ya estaba; con error = el mensaje.
   2.º disparador «al intentar irse» (V2h, 12/10/2026), con las mismas reglas (una vez, nunca con algo abierto, nunca
   antes del mínimo, sin reloj): en el celular, una subida rápida hasta arriba (de 2 pantallas de hondo al tope en
   menos de 0,9 s); en escritorio, el mouse que sale de la ventana por arriba. Se detecta con IntersectionObserver
   (dos marcadores, medidos una vez), sin leer medidas en el scroll. Si en ese momento hay algo abierto, no se
   insiste: el reloj y la mitad de página siguen como siempre.
   Al tocar «Copiar» se guarda el código en localStorage «gs-codigo-copiado» (try/catch): el carrito ofrece
   aplicarlo de un toque (assets/gs-cart-codigo.js). */
(function () {
  'use strict';
  var CLAVE = 'gs-news';
  var DIA = 86400000;
  var TXT = {
    vacio: 'Escribí tu email para recibir el código.',
    mal: 'Revisá el email: le falta algo.',
    enviando: 'Enviando…'
  };
  var ABIERTOS = 'cart-drawer[open],menu-drawer[open],drawer-component[open],modal-component[open],basic-modal[open],' +
    'quick-view-modal[open],compare-drawer[open],.drawer[open],dialog[open]:not([data-gs-news]),.gs-toast.is-open';

  function leer() { try { return window.localStorage.getItem(CLAVE); } catch (e) { return null; } }
  function guardar(v) { try { window.localStorage.setItem(CLAVE, v); return true; } catch (e) { return false; } }
  function sePuedeGuardar() {
    try { window.localStorage.setItem('gs-news-prueba', '1'); window.localStorage.removeItem('gs-news-prueba'); return true; } catch (e) { return false; }
  }
  var QS = window.location.search;
  var POSTEADO = /[?&]customer_posted=true/.test(QS);
  if (POSTEADO) guardar('suscripto');

  function algoAbierto() {
    var c = document.body.classList;
    if (c.contains('modal-show') || c.contains('modal-showing') || c.contains('search-open') || c.contains('has-dropdown-menu')) return true;
    if (document.querySelector(ABIERTOS)) return true;
    var a = document.activeElement;
    return !!(a && (a.tagName === 'INPUT' || a.tagName === 'TEXTAREA' || a.tagName === 'SELECT' || a.isContentEditable));
  }
  function emailOk(v) { return /^[^\s@]+@[^\s@.]+(\.[^\s@.]+)*\.[a-z][a-z0-9-]+$/i.test(v); }
  function cssListo(cb) {
    var l = document.querySelector('link[data-gs-news-css]');
    if (!l || l.media === 'all' || l.sheet) { if (l) l.media = 'all'; cb(); return; }
    var hecho = false;
    function ir() { if (hecho) return; hecho = true; l.media = 'all'; cb(); }
    l.addEventListener('load', ir, { once: true });
    setTimeout(ir, 1500);
  }

  function init(d) {
    if (d.dataset.gsNewsInit) return;
    d.dataset.gsNewsInit = '1';
    var enEditor = !!(window.Shopify && window.Shopify.designMode);
    var form = d.querySelector('form');
    var email = d.querySelector('.gs-news__email');
    var btn = d.querySelector('.gs-news__btn');
    var msj = d.querySelector('.gs-news__msj');
    var caja = d.querySelector('.gs-news__caja');
    var pasoForm = d.querySelector('[data-paso="form"]');
    var pasoOk = d.querySelector('[data-paso="exito"]');
    var titOk = pasoOk.querySelector('.gs-news__tit');
    var textoOk = pasoOk.querySelector('[data-gs-news-texto]');
    var tplYa = pasoOk.querySelector('template[data-gs-news-ya]');
    var marca = d.querySelector('[data-gs-news-post]');
    var post = marca ? marca.getAttribute('data-gs-news-post') : '';
    var errLiquid = marca ? marca.getAttribute('data-gs-news-err') : '';
    var dias = parseFloat(d.dataset.dias) || 7;
    var textoNuevo = textoOk.innerHTML;
    if (form) form.noValidate = true;

    /* ---------- estados ---------- */
    function error(t) {
      msj.textContent = t || '';
      if (t) email.setAttribute('aria-invalid', 'true');
      else email.removeAttribute('aria-invalid');
    }
    function exito(ya) {
      titOk.textContent = ya ? (titOk.getAttribute('data-ya') || titOk.textContent) : titOk.getAttribute('data-nuevo');
      textoOk.innerHTML = ya && tplYa ? tplYa.innerHTML : textoNuevo;
      pasoForm.hidden = true;
      pasoOk.hidden = false;
      d.setAttribute('aria-labelledby', titOk.id);
      d.removeAttribute('aria-describedby');
      if (d.open) {
        try { titOk.focus({ preventScroll: true }); } catch (e) { titOk.focus(); }
      }
    }
    function enviando(si) {
      btn.setAttribute('aria-busy', si ? 'true' : 'false');
      btn.textContent = si ? TXT.enviando : btn.getAttribute('data-texto');
    }

    /* ---------- abrir y cerrar ---------- */
    var vv = window.visualViewport;
    var hoja = window.matchMedia('(max-width: 767.98px)');
    var cuadro = null;
    function ajustarTeclado() {
      cuadro = null;
      /* Con el teclado abierto (iOS: solo se achica la vista visible) la hoja sube hasta el borde del teclado,
         se compacta (sin sello, segunda línea ni letra chica) y deja a la vista el botón. Una medida por evento. */
      var tapa = d.open && hoja.matches && vv ? Math.round(window.innerHeight - (vv.height + vv.offsetTop)) : 0;
      var teclado = tapa > 120;
      d.style.bottom = tapa > 1 ? tapa + 'px' : '';
      d.style.maxHeight = tapa > 1 ? Math.round(vv.height - 8) + 'px' : '';
      d.classList.toggle('gs-news--teclado', teclado);
      if (teclado && document.activeElement === email) {
        var falta = btn.offsetTop + btn.offsetHeight + 12 - caja.clientHeight;
        if (falta > caja.scrollTop) caja.scrollTop = falta;
      }
    }
    function alMoverVista() {
      if (cuadro) return;
      cuadro = setTimeout(ajustarTeclado, 30);
    }
    function abrir(registrar) {
      if (d.open) return;
      cssListo(function () {
        if (d.open) return;
        if (registrar && leer() !== 'suscripto') guardar('cerrado:' + Date.now());
        if (typeof d.showModal === 'function') {
          try { d.showModal(); } catch (e) { d.setAttribute('open', ''); }
        } else {
          d.setAttribute('open', '');
        }
        document.documentElement.classList.add('gs-news-abierto');
        abiertoEn = Date.now(); gestoViejo = dedoApoyado;
        if (vv) { vv.addEventListener('resize', alMoverVista); vv.addEventListener('scroll', alMoverVista); }
        if (!pasoOk.hidden) { try { titOk.focus({ preventScroll: true }); } catch (e) {} }
      });
    }
    function cerrar() {
      if (typeof d.close === 'function' && d.open) d.close();
      else if (d.hasAttribute('open')) { d.removeAttribute('open'); alCerrar(); }
    }
    function alCerrar() {
      if (d.open) return; /* se volvió a abrir sin modal para el captcha (soltar) */
      d.classList.remove('gs-news--suelto');
      document.documentElement.classList.remove('gs-news-abierto');
      if (vv) { vv.removeEventListener('resize', alMoverVista); vv.removeEventListener('scroll', alMoverVista); }
      d.style.bottom = ''; d.style.maxHeight = ''; d.style.transform = '';
      d.classList.remove('gs-news--teclado');
      if (!enEditor && leer() !== 'suscripto') guardar('cerrado:' + Date.now());
    }
    d.addEventListener('close', alCerrar);

    /* «Copiar» (snippets/gs-codigo.liquid copia; acá solo se recuerda para ofrecerlo en el carrito) */
    d.addEventListener('click', function (e) {
      var b = e.target && e.target.closest ? e.target.closest('[data-gs-copiar]') : null;
      if (!b) return;
      var cod = String(b.getAttribute('data-gs-copiar') || '').trim().toUpperCase();
      if (!cod) return;
      try { window.localStorage.setItem('gs-codigo-copiado', cod); } catch (err) {}
      try { document.dispatchEvent(new CustomEvent('gs:codigo-copiado', { detail: { codigo: cod } })); } catch (err) {}
    });

    /* tocar afuera: el fondo es el propio <dialog>; solo cierra si el toque empezó y terminó afuera */
    var abajoAfuera = false;
    d.addEventListener('pointerdown', function (e) { abajoAfuera = e.target === d; });
    d.addEventListener('click', function (e) {
      if (e.target.closest('[data-gs-news-cerrar]')) { e.preventDefault(); cerrar(); return; }
      if (e.target === d && abajoAfuera) cerrar();
    });

    /* deslizar la hoja hacia abajo para cerrarla (celular): solo desde arriba, sin tocar campos ni botones.
       Si se abrió en medio de un deslizamiento (el «al intentar irse» salta mientras la persona sube con el dedo
       apoyado), ese mismo gesto no la cierra: hace falta levantar el dedo y apoyarlo de nuevo, y nunca en los
       primeros 600 ms. */
    var y0 = null, dy = 0, abiertoEn = 0, dedoApoyado = false, gestoViejo = false;
    document.addEventListener('touchstart', function () { dedoApoyado = true; }, { passive: true, capture: true });
    function soltoDedo(e) { if (!e.touches || !e.touches.length) { dedoApoyado = false; gestoViejo = false; } }
    document.addEventListener('touchend', soltoDedo, { passive: true, capture: true });
    document.addEventListener('touchcancel', soltoDedo, { passive: true, capture: true });
    d.addEventListener('touchstart', function (e) {
      y0 = null;
      if (!hoja.matches || e.touches.length !== 1) return;
      if (gestoViejo || Date.now() - abiertoEn < 600) return;
      if (e.target.closest('input, button, a, label, .gs-codigo')) return;
      if (caja.scrollTop > 0) return;
      y0 = e.touches[0].clientY; dy = 0;
    }, { passive: true });
    d.addEventListener('touchmove', function (e) {
      if (y0 === null) return;
      dy = Math.max(0, e.touches[0].clientY - y0);
      d.style.transform = dy > 4 ? 'translateY(' + dy + 'px)' : '';
    }, { passive: true });
    d.addEventListener('touchend', function () {
      if (y0 === null) return;
      y0 = null;
      d.style.transform = '';
      if (dy > 90) cerrar();
    }, { passive: true });

    /* ---------- suscribirse ----------
       Envío NORMAL (con recarga): la tienda tiene la protección anti-bots de Shopify (hCaptcha) en los formularios
       de clientes y su script es el que termina de mandarlo. Por eso:
       - email vacío o mal escrito: se frena acá y no llega ni al captcha ni a la tienda;
       - email bien: se deja pasar y la hoja deja de ser modal, así un desafío del captcha se puede responder
         (un <dialog> modal tapa todo, incluso el captcha);
       - al volver (customer_posted=true#GsNews-...) el pop-up se abre solo con el código. */
    function soltar() {
      if (!d.open || d.classList.contains('gs-news--suelto') || typeof d.show !== 'function') return;
      d.close();
      d.show();
      d.classList.add('gs-news--suelto');
    }
    if (form) form.addEventListener('submit', function (e) {
      var v = (email.value || '').trim();
      email.value = v;
      var mal = !v ? TXT.vacio : (emailOk(v) ? '' : TXT.mal);
      if (mal || enEditor) { e.preventDefault(); e.stopImmediatePropagation(); }
      if (mal) { error(mal); email.focus(); return; }
      error('');
      if (enEditor) { exito(false); return; }
      enviando(true);
      soltar();
      clearTimeout(enviando.t);
      enviando.t = setTimeout(function () { enviando(false); }, 8000);
    });

    /* ---------- en el editor ---------- */
    if (enEditor) {
      if (d.hasAttribute('data-ver-exito')) exito(false);
      document.addEventListener('shopify:section:select', function (e) { if (e.target.contains(d)) abrir(false); });
      document.addEventListener('shopify:section:deselect', function (e) { if (e.target.contains(d)) cerrar(); });
      var sec = d.closest('.shopify-section');
      if (sec && sec.hasAttribute('data-gs-news-recargada')) abrir(false);
      return;
    }

    /* ---------- vuelta de un envío normal (captcha) a este mismo formulario ---------- */
    if (window.location.hash === '#' + d.dataset.form) {
      if (post === 'ok' || POSTEADO) { guardar('suscripto'); exito(false); }
      else if (post === 'error') error(errLiquid || TXT.mal);
      else if (/[?&]form_type=customer/.test(QS)) { guardar('suscripto'); exito(true); }
      var mostrar = function () {
        /* el aviso del pie (tema) también salta con cualquier formulario de cliente: se cierra para no apilar dos */
        document.querySelectorAll('basic-modal[id^="NewsletterAlertModal-"][open]').forEach(function (m) { if (m.hide) m.hide(); });
        abrir(false);
      };
      if (document.readyState === 'complete') setTimeout(mostrar, 300);
      else window.addEventListener('load', function () { setTimeout(mostrar, 300); }, { once: true });
      return;
    }

    /* ---------- ¿le toca? ---------- */
    var visto = leer();
    if (visto === 'suscripto') return;
    if (visto) {
      var t = parseInt(String(visto).split(':')[1], 10);
      if (t > 0 && Date.now() - t < dias * DIA) return;
    }
    if (!sePuedeGuardar()) return;
    programar();

    function programar() {
      var segundos = (parseFloat(d.dataset.segundos) || 20) * 1000;
      var minimo = (parseFloat(d.dataset.minimo) || 0) * 1000;
      var ahora = function () { return window.performance && performance.now ? performance.now() : 0; };
      var hecho = false, reloj = null, reintento = null, io = null, marcador = null;

      function disparar() {
        if (hecho) return;
        if (algoAbierto()) { clearTimeout(reintento); reintento = setTimeout(disparar, 3000); return; }
        hecho = true;
        clearTimeout(reloj); clearTimeout(reintento);
        if (io) io.disconnect();
        if (marcador && marcador.parentNode) marcador.parentNode.removeChild(marcador);
        abrir(true);
      }
      function mitadPasada() {
        var falta = minimo - ahora();
        if (falta > 0) setTimeout(disparar, falta); else disparar();
      }
      reloj = setTimeout(disparar, Math.max(0, segundos - ahora()));

      function vigilarMitad() {
        if (hecho || !('IntersectionObserver' in window)) return;
        /* mientras el tema no soltó las secciones de abajo todavía no tienen su alto: esperar */
        if (document.body.hasAttribute('data-initializing')) { setTimeout(vigilarMitad, 600); return; }
        var mitad = Math.round(document.documentElement.scrollHeight / 2);
        if ((window.pageYOffset || 0) + window.innerHeight >= mitad) { mitadPasada(); return; }
        marcador = document.createElement('div');
        marcador.setAttribute('aria-hidden', 'true');
        /* display:block: el tema esconde los div vacíos (div:empty) y un marcador sin caja nunca se cruza (pasaba: la mitad no disparaba) */
        marcador.style.cssText = 'display:block !important;position:absolute;left:0;top:' + mitad + 'px;width:1px;height:1px;pointer-events:none;visibility:hidden';
        document.body.appendChild(marcador);
        io = new IntersectionObserver(function (en) {
          if (en[0] && en[0].isIntersecting) { io.disconnect(); mitadPasada(); }
        }, { threshold: 0 });
        io.observe(marcador);
      }
      window.addEventListener('scroll', function () { setTimeout(vigilarMitad, 500); setTimeout(vigilarSubida, 500); }, { once: true, passive: true });
      vigilarMouse();

      /* ---------- 2.º disparador: al intentar irse ---------- */
      function alIrse() {
        if (hecho) return;
        if (ahora() < minimo) return;      /* nunca apenas se entra */
        if (algoAbierto()) return;         /* nunca encima de otra cosa; no se reintenta (ya no se está yendo) */
        disparar();
      }
      function tactil() { return window.matchMedia('(hover: none), (pointer: coarse)').matches; }
      function vigilarMouse() {
        if (tactil()) return;
        /* escritorio: el mouse sale de la ventana por arriba (hacia las pestañas o la barra de direcciones) */
        var salir = function (e) {
          if (hecho) { document.removeEventListener('mouseout', salir); return; }
          if (e.relatedTarget || e.toElement) return;
          if (typeof e.clientY === 'number' && e.clientY > 8) return;
          alIrse();
        };
        document.addEventListener('mouseout', salir);
      }
      function vigilarSubida() {
        /* celular: subida rápida hasta arriba. Dos marcadores invisibles desde el tope de la página: «hondo», de
           2 pantallas de alto, y «tope», de 200 px. «hondo» deja de cruzarse cuando se bajó más de 2 pantallas (se arma)
           y se vuelve a cruzar al subir de esa altura; si «tope» entra menos de 0,9 s después, fue una subida rápida.
           «hondo» es alto a propósito: una línea de 1 px se puede saltear entera en un cuadro y el observador no avisa.
           Se arma después del primer scroll, con el alto ya armado (medido una vez): en una página de menos de
           3 pantallas no se pone (el marcador estiraría la página). */
        if (hecho || !tactil() || !('IntersectionObserver' in window)) return;
        if (document.body.hasAttribute('data-initializing')) { setTimeout(vigilarSubida, 600); return; }
        var vh = window.innerHeight || 700;
        if (document.documentElement.scrollHeight < vh * 3 + 200) return;
        function marca(top, alto) {
          var m = document.createElement('div');
          m.setAttribute('aria-hidden', 'true');
          m.style.cssText = 'display:block !important;position:absolute;left:0;top:' + top + 'px;width:1px;height:' + alto + 'px;pointer-events:none;visibility:hidden';
          document.body.appendChild(m);
          return m;
        }
        var hondo = marca(0, Math.round(vh * 2));
        var tope = marca(0, 200);
        var arriba = false, tHondo = 0, topeVisible = true;
        var io2 = new IntersectionObserver(function (ens) {
          /* primero «hondo», después «tope»: pueden llegar juntos en el mismo cuadro (salto directo al tope) */
          ens.sort(function (a, b) { return (a.target === hondo ? 0 : 1) - (b.target === hondo ? 0 : 1); });
          ens.forEach(function (en) {
            if (en.target === hondo) {
              if (!en.isIntersecting) { if (en.boundingClientRect.bottom <= 0) arriba = true; } /* bajó más de 2 pantallas */
              else if (arriba) { arriba = false; tHondo = en.time; }                           /* volvió a subir */
            } else if (en.target === tope) {
              var antes = topeVisible;
              topeVisible = en.isIntersecting;
              if (en.isIntersecting && !antes && tHondo) {
                var rapido = en.time - tHondo < 900;
                tHondo = 0;
                if (rapido) alIrse();
              }
            }
          });
          if (hecho) { io2.disconnect(); [hondo, tope].forEach(function (m) { if (m.parentNode) m.parentNode.removeChild(m); }); }
        }, { threshold: 0 });
        io2.observe(hondo);
        io2.observe(tope);
      }
    }
  }

  function todos() { document.querySelectorAll('dialog[data-gs-news]').forEach(init); }
  if (document.readyState !== 'loading') todos();
  else document.addEventListener('DOMContentLoaded', todos);
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('dialog[data-gs-news]')) {
      e.target.setAttribute('data-gs-news-recargada', '');
      todos();
    }
  });
})();
